export default "__VITE_ASSET__DG8U$9$Z__"